<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :footer="null"
    :mask-closable="false"
    @cancel="TipDialogVisible=false"
  >
    <div
      v-if="type==='delItem'"
      class="dialog-tip-box webhook-dialog-tip"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>删除Webhook</h2>
      <div class="d-tip-con">
        删除后该webhook接收地址将不再接收星轨的数据<br>推送，确定要删除吗？
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="operateItem"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
    <div
      v-if="type==='sendItem'"
      class="dialog-tip-box webhook-dialog-tip"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>再次推送</h2>
      <div class="d-tip-con">
        确定要再次推送该条数据吗？
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="operateItem"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
    <div
      v-if="type==='up'"
      class="dialog-tip-box webhook-dialog-tip"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>Webhook功能不可用 </h2>
      <div class="d-tip-con">
       Webhook功能内容仅支持高级版项目，当前项目版本为免费版，升级后可使用Webhook功能。
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="upgrade"
        >
          {{ $t('message["599"]') }}
        </a-button>
        <a-button
          @click="TipDialogVisible=false"
        >
          {{ $t('message["1005"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    operateItem (val) {
      this.$emit('operateItem')
      // this.TipDialogVisible = false
    },
    upgrade () {
      this.$router.push({ name: 'ServiceIndex' })
    }
    // triggerTransfer () {
    //   this.$emit('delWebhook')
    // }
  }
}
</script>
<style lang="scss" scoped>
.webhook-dialog-tip {
  .d-tip-con {
    margin-bottom: 16px;
  }
}
</style>
